import Home from "./pages/Home";
import TeacherCVContextProvider from "./context/teacherCVContext";

function App() {
    return (
        <TeacherCVContextProvider>
            <Home />
        </TeacherCVContextProvider>
    );
}

export default App;
